<template>
  <div ref="box">
    <ul class="nav" ref="elememtNav">
      <li
        @click="current = 1;classifiedCourses(1,'',1,'');fromcurrent='';getHeight();changeUrl(current,0)"
        :class="{ active: current == 1 }"
      >
        <div class="nav_img">
          <img v-if="current == 1" src="../../../public/images/course/jp_b.png" alt />
          <img v-else src="../../../public/images/course/jp1.png" alt />
        </div>
        <p class="nav_title" :class="{ active: current == 1 }">精品课程</p>
      </li>
      <li
        @click="current = 3;classifiedCourses('','',1,'');activeClass = 0;getHeight();fromcurrent='';changeUrl(current,0)"
        :class="{ active: current == 3 }"
      >
        <div class="nav_img">
          <img v-if="current == 3" src="../../../public/images/course/qb_b.png" alt />
          <img v-else src="../../../public/images/course/qb1.png" alt />
        </div>
        <p class="nav_title" :class="{ active: current == 3 }">全部视频</p>
      </li>
      <li
        @click="current = 2;classifiedCourses(2,'',1,'');fromcurrent='';getHeight();changeUrl(current,0)"
        :class="{ active: current == 2 }"
      >
        <div class="nav_img">
          <img v-if="current == 2" src="../../../public/images/course/gp_b.png" alt />
          <img v-else src="../../../public/images/course/gp1.png" alt />
        </div>
        <p class="nav_title" :class="{ active: current == 2 }">股票百科</p>
      </li>
      <li
        @click="current = 4;classifiedCourses(4,'',1,'');fromcurrent='';getHeight();changeUrl(current,0)"
        :class="{ active: current == 4 }"
      >
        <div class="nav_img">
          <img v-if="current == 4" src="../../../public/images/course/rd_b.png" alt />
          <img v-else src="../../../public/images/course/rd1.png" alt />
        </div>
        <p class="nav_title" :class="{ active: current == 4 }">热点解读</p>
      </li>
    </ul>
    <div class="content" ref="contentbox" @touchmove="handleScroll" @scroll="handleScroll">
      <div v-show="current == 1" ref="main_content1">
        <ul class="main">
          <li
            @click="getInfo(item.courseId,item.free)"
            v-for="item in courseList"
            :key="item.courseId"
            style="position:relative;"
          >
            <div class="main_box">
              <div>
                <img
                  v-if="item.hot"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/hot.png"
                  alt
                />
                <img
                  v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/new.png"
                  alt
                />
              </div>
              <div class="main_left">
                <img :src="item.imageUrl" alt />
              </div>
              <div class="main_right">
                <p class="video_name">{{item.name}}</p>
                <p class="video_teacher">{{item.teacher}}</p>
                <div class="img_tab">
                  <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                </div>
                <p class="video_all_left">
                  观看
                  <span>{{item.viewQuantity}}</span>
                </p>
                <p class="video_all_right">{{(item.onlineTime?item.onlineTime.slice(0,10):'')}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="current == 3" ref="main_content3">
        <div class="tab">
          <span
            class="tab_all"
            :class="activeClass == 0 ? 'tab_active' : ''"
            @click="classifiedCourses('','',1,'');activeClass = 0;loading = false;fromcurrent=''"
          >全部</span>
          <div class="tab_infos">
            <span
              class="tab_info"
              :class="activeClass == item.labelCode ? 'tab_active' : ''"
              @click="getListTab(item.labelCode);loading = false;fromcurrent=''"
              v-for="item in courseLabels"
              :key="item.labelCode"
            >{{item.labelName}}</span>
          </div>
        </div>
        <ul class="main">
          <li
            @click="getInfo(item.courseId)"
            v-for="item in courseList"
            :key="item.courseId"
            style="position:relative;"
          >
            <div class="main_box">
              <div>
                <img
                  v-if="item.hot"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/hot.png"
                  alt
                />
                <img
                  v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/new.png"
                  alt
                />
              </div>
              <div class="main_left">
                <img :src="item.imageUrl" alt />
                <!-- <img src="../../../public/images/course/tx.png" alt /> -->
              </div>
              <div class="main_right">
                <p class="video_name">{{item.name}}</p>
                <p class="video_teacher">{{item.teacher}}</p>
                <div class="img_tab">
                  <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                </div>
                <p class="video_all_left">
                  观看
                  <span>{{item.viewQuantity}}</span>
                </p>
                <p class="video_all_right">{{(item.onlineTime?item.onlineTime.slice(0,10):'')}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="current == 2" ref="main_content2">
        <ul class="main">
          <li
            @click="getInfo(item.courseId)"
            v-for="item in courseList"
            :key="item.courseId"
            style="position:relative;"
          >
            <div class="main_box">
              <div>
                <img
                  v-if="item.hot"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/hot.png"
                  alt
                />
                <img
                  v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/new.png"
                  alt
                />
              </div>
              <div class="main_left">
                <img :src="item.imageUrl" alt />
              </div>
              <div class="main_right">
                <p class="video_name">{{item.name}}</p>
                <p class="video_teacher">{{item.teacher}}</p>
                <div class="img_tab">
                  <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                </div>
                <p class="video_all_left">
                  观看
                  <span>{{item.viewQuantity}}</span>
                </p>
                <p class="video_all_right">{{(item.onlineTime?item.onlineTime.slice(0,10):'')}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="current == 4" ref="main_content4">
        <ul class="main">
          <li
            @click="getInfo(item.courseId)"
            v-for="item in courseList"
            :key="item.courseId"
            style="position:relative;"
          >
            <div class="main_box">
              <div>
                <img
                  v-if="item.hot"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/hot.png"
                  alt
                />
                <img
                  v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                  style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                  src="../../../public/images/new.png"
                  alt
                />
              </div>
              <div class="main_left">
                <img :src="item.imageUrl" alt />
              </div>
              <div class="main_right">
                <p class="video_name">{{item.name}}</p>
                <p class="video_teacher">{{item.teacher}}</p>
                <div class="img_tab">
                  <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                </div>
                <p class="video_all_left">
                  观看
                  <span>{{item.viewQuantity}}</span>
                </p>
                <p class="video_all_right">{{(item.onlineTime?item.onlineTime.slice(0,10):'')}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Header />
  </div>
</template>
<script>
import Header from "../../components/Header";
import {
  HomeCourses,
  ClassifiedCourses,
  CoursesLabels
} from "../../utils/http.js";
import util from "../../utils/util.js";
// import emH5Share from "../emH5Share.js";
export default {
  name: "course",
  components: {
    Header
  },
  data() {
    return {
      current: 1,
      activeClass: 0,
      courseLabels: [],
      courseList: [],
      n: 0,
      courseCategory: "",
      loading: false,
      top: 0,
      from: 1,
      fromcurrent: 0,
      page: 1,
      date: new Date(),
      miniToken: ""
    };
  },
  mounted() {
    // emH5.ShareData = {
    //   title: "金牌课程",
    //   desc: "为您精选投资课程",
    //   link: window.location.href,
    //   // imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
    //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
    //   fail: function(res) {
    //     alert(JSON.stringify(res));
    //   }
    // };
    // emH5.Share();
    window.scrollTo(0, 0);
    window.AG.setTitle("课程");
    this.coursesLabels();
    this.getParams();
    this.getHeight();
    this.overscroll(document.querySelector(".content"));
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  created() {
    // let self = this;
    // self.getParams();
  },
  destroyed() {
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
  },
  watch: {
    // $route: "getParams"
    // current(val) {
    //   let path = this.$router.history.current.path;
    //   console.log(val);
    //   this.$router.push({ path, query: { n: val, from: this.fromcurrent } });
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    // }
  },
  methods: {
    changeUrl(v, u) {
      window.history.replaceState(null, null, "#/course?from=" + u + "&n=" + v);
      // util.cancelRequest();
    },
    getHeight() {
      this.$refs.contentbox.scrollTop = 0;
      let heightNav = this.$refs.elememtNav.offsetHeight;
      let heightWindow = window.innerHeight;
      let heightMain = heightWindow - heightNav - 68;
      this.$refs.contentbox.style.height = heightMain + "px";
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop = this.$refs.contentbox.scrollTop;
      var scroll = scrollTop - this.top;
      this.top = scrollTop;
      if (scroll >= 0) {
        this.srollTest();
      }
    },
    srollTest(main_content) {
      var allHeight;
      if (this.current == 1) {
        allHeight = this.$refs.main_content1.offsetHeight - 30;
      } else if (this.current == 2) {
        allHeight = this.$refs.main_content2.offsetHeight - 30;
      } else if (this.current == 3) {
        allHeight = this.$refs.main_content3.offsetHeight - 30;
      } else if (this.current == 4) {
        allHeight = this.$refs.main_content4.offsetHeight - 30;
      }
      if (
        this.$refs.contentbox.scrollTop + this.$refs.contentbox.offsetHeight >
        allHeight
      ) {
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.page++;
        this.GetclassifiedCourses(
          this.courseCategory,
          this.courselabel,
          this.page,
          this.fromcurrent
        );
      }
    },
    homeCourse() {
      HomeCourses({}).then(res => {
        if (res.data.code == 0) {
          this.bestCourseList = res.data.data.bestCourseList;
          this.hotCourseList = res.data.data.hotCourseList;
          this.newestCourseList = res.data.data.newestCourseList;
        }
      });
    },
    coursesLabels() {
      CoursesLabels({}).then(res => {
        if (res.data.code == 0) {
          this.courseLabels = res.data.data;
        }
      });
    },
    classifiedCourses(v, u, page, type) {
      ClassifiedCourses({
        courseCategory: v,
        courselabel: u,
        pageNum: page,
        pageSize: 10,
        from: type
      }).then(res => {
        if (res.data.code == 0) {
          this.courseList = res.data.data.courseList;
          this.courseCategory = v;
          this.courselabel = u;
          this.page = page;
          this.loading = false;
        }
      });
    },
    getParams() {
      this.current = this.$route.query.n;
      this.fromcurrent = this.$route.query.from;
      if (this.current == 3) {
        this.classifiedCourses("", this.courselabel, 1, this.fromcurrent);
      } else {
        this.classifiedCourses(this.current, "", 1, "");
      }
    },
    getInfo(v, u) {
      this.$router.push({
        path: "/courseInfo",
        query: { courseId: v }
      });
    },
    getListTab(v) {
      this.activeClass = v;
      if (v == 0) {
        this.$router.push({ path: "/course", query: { n: 3, from: 0 } }); //全部
      } else {
        this.classifiedCourses(this.courseCategory, v, 1, "");
      }
    }, //点击标签更换列表
    GetclassifiedCourses(v, u, page, type) {
      ClassifiedCourses({
        courseCategory: v,
        courselabel: u,
        pageNum: page,
        pageSize: 10,
        from: type
      }).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.courseList.length != 0) {
            this.courseList = this.courseList
              .slice(0, this.courseList.length)
              .concat(res.data.data.courseList);
            this.courseCategory = v;
            this.courselabel = u;
            this.page = page;
            this.loading = false;
          } else {
            this.loading = true;
          }
        }
      });
    }, //滚动加载
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // var hours =
      //   date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      // var minutes =
      //   date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // var seconds =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    }
  }
};
</script>
<style scoped>
.nav {
  width: 7.5rem;
  height: 1.75rem;
  font-size: 0.3rem;
  background-color: #fff;
}
.nav li {
  display: inline-block;
  width: 1.86rem;
  padding: 0.24rem 0;
}
.nav_img {
  width: 0.52rem;
  height: 0.46rem;
  padding: 0.19rem 0.42rem 0.1rem 0.65rem;
}
.nav_img img {
  width: 100%;
  height: 100%;
}
.nav_title {
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  color: #6f6f6f;
}
.active {
  color: #f5601a;
}
.content {
  width: 7.5rem;
  background-color: #f6f6f6;
  /* padding: 0.3rem 0 1.4rem; */
  padding: 0.3rem 0 0;
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.main {
  width: 7.5rem;
  background-color: #fff;
}
.main li {
  width: 7.5rem;
}
.main_box {
  width: 7.07rem;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  overflow: hidden;
}
.main_left {
  float: left;
  width: 3.33rem;
  height: 2.1rem;
  padding: 0.25rem 0.06rem;
  /* padding: 0.25rem 0.06rem 0.65rem; */
}
.main_left img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.main_right {
  float: right;
  width: 3.5rem;
}
.video_name {
  line-height: 0.57rem;
  font-size: 0.35rem;
  margin-top: 0.25rem;
  text-align: left;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.video_teacher {
  line-height: 0.35rem;
  font-size: 0.25rem;
  text-align: left;
  color: #666666;
}
.img_tab {
  width: 3.5rem;
  height: 0.45rem;
  /* margin: 0.3rem 0 0.42rem; */
  margin: 0.3rem 0;
  overflow: hidden;
}
.img_tab p {
  float: left;
  height: 0.38rem;
  /* line-height: 0.38rem; */
  border: 1px solid #ea5503;
  border-radius: 30px 30px;
  margin: 0 0.13rem 0.2rem 0;
  font-size: 0.2rem;
  color: #ea5503;
  padding: 0 0.1rem;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.video_all {
  text-align: right;
  width: 3.5rem;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.25rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
.video_all_left {
  float: left;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.25rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
.video_all_right {
  float: right;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.25rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
.tab {
  background-color: #fff;
  padding: 0.2rem 0.9rem 0.2rem 0.26rem;
  margin-bottom: 0.28rem;
  overflow: hidden;
}
.tab_all {
  float: left;
  width: 0.84rem;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.28rem;
  color: #666666;
  padding: 0.05rem;
}
.tab_infos {
  float: right;
  width: 5.25rem;
}
.tab_infos span {
  float: left;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.28rem;
  color: #666666;
  margin-right: 0.1rem;
  padding: 0.05rem;
}
.tab .tab_active {
  color: #e95606;
  background-color: #fff8f2;
  border-radius: 8px;
}
</style>
